import { render, staticRenderFns } from "./QuoteBox.vue?vue&type=template&id=574acdb4&"
import script from "./QuoteBox.vue?vue&type=script&lang=js&"
export * from "./QuoteBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports